export const IE_EXTENSION_DOWNLOAD_LINK =
  "https://s3.amazonaws.com/onelogin-downloads/extensions/ie/onelogin_ie.exe";
export const FIREFOX_EXTENSION_DOWNLOAD_LINK =
  "https://s3.amazonaws.com/onelogin-downloads/extensions/firefox/onelogin.xpi";
export const EDGE_EXTENSION_DOWNLOAD_LINK =
  "https://www.microsoft.com/en-us/store/p/onelogin-for-edge/9nblggh40z7w";
export const SAFARI_EXTENSION_DOWNLOAD_LINK =
  "https://apps.apple.com/us/app/onelogin-for-safari/id1475824389?mt=12";
export const CHROME_EXTENSION_DOWNLOAD_LINK =
  "https://chrome.google.com/webstore/detail/onelogin-for-google-chrom/ioalpmibngobedobkmbhgmadaphocjdn";
